import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const BharatSatService = {
  addStudentBatch: async (
    classId,
    medium,
    state,
    district,
    numberOfStudents
  ) => {
    try {
      const response = await axios.post(
        ApiConstants.addStudentBatch,
        {
          classId: classId,
          medium: medium,
          state: state,
          district: district,
          numberOfStudents: numberOfStudents,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  
  CreateBharatsatExam: async (bharatSatExamId, bharatSatExamName, bharatSatExamDate, examStartTime,examEndTime,medium,classId,durationInMinutes,subjectData,generateHallTicketDate,negativeMarking) => {
    try {
      const response = await axios.post(
        ApiConstants.addBharatSatExam,
        {
          bharatSatExamId: bharatSatExamId,
          bharatSatExamName: bharatSatExamName,
          bharatSatExamDate: bharatSatExamDate,
          examStartTime:examStartTime,
          examEndTime:examEndTime,
          medium: medium?.trim(),
          class_id: classId,
          durationInMinutes: durationInMinutes,
          subjectData:subjectData,
          generateHallTicketDate,
          negativeMarking
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getBharatSatExamList: async (offset, limit, searchQuery,selectedClassFilter,selectedMedium) => {
    try {
      const response = await axios.get(
        ApiConstants.getBharatSatExamList +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery} ` +  `&class_id=${selectedClassFilter}` + 
          `&medium=${selectedMedium}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getStudentBatchList: async (offset, limit, searchQuery,bharatSatExamId) => {
    try {
      const response = await axios.get(
        ApiConstants.getStudentBatchList +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery}&bharatSatExamId=${bharatSatExamId}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getStudentBatchListWithoutPagination: async (bharatSatExamId) => {
    try {
      const response = await axios.get(
        ApiConstants.getStudentBatchListWithoutPagination +
          `?bharatSatExamId=${bharatSatExamId}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  updateBharatSatExamStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.changeStatusBharatSatExam,
        {
          id: id,
          is_active: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  deleteBharatSatExam: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteBharatSatExam,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  deleteStudentBatch: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteStudentBatch,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  bharatSatQuestionsDetails: async (bharatSatExamId) => {
    try {
      const response = await axios.get(ApiConstants.bharatSatQuestionsDetails + `?bharatSatExamId=${bharatSatExamId}`, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  generatehallticketbhratsat: async (bharatSatExamId) => {
    try {
      const response = await axios.get(ApiConstants.generatehallticketbhratsat + `?bharatSatExamId=${bharatSatExamId}`, {
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
        responseType: 'blob',
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  editStudentDetails: async (userId, firstName, middleName, lastName, dateOfBirth, gender,schoolName,classId,medium,email,mobile, addressLineOne, addressLineTwo, state, district, taluka, pinCode) => {
    try {
        const response = await axios.post(
            ApiConstants.editStudentDetails,
            {
              userId: userId,
                firstName: firstName,
                middleName: middleName,
                lastName: lastName,
                dateOfBirth: dateOfBirth,
                gender: gender,
                schoolName:schoolName,
                classId:classId,
                medium:medium,
                email:email,
                mobile:mobile,
                addressLineOne: addressLineOne,
                addressLineTwo: addressLineTwo,
                state: state,
                district: district,
                taluka: taluka,
                pinCode: pinCode,
            },
            {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                },
            }
        );
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response.error);
        }
    } catch (error) {
        throw error;
    }
},
getBharatSatExamResult: async (offset, limit, searchQuery,selectedClassFilter,selectedMedium,selectedDistrictFilter,selectedTalukaFilter,selectedBharatSatExamNameFilter) => {
  try {
    const response = await axios.get(
      ApiConstants.getBharatSatExamReult +
        `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}` +  `&class_id=${selectedClassFilter}` + 
        `&medium=${selectedMedium}` + 
        `&searchDistrict=${selectedDistrictFilter}` + 
        `&searchTaluka=${selectedTalukaFilter}`+
        `&bharatSatExamNames=${selectedBharatSatExamNameFilter}`,
      {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.error);
    }
  } catch (error) {
    throw error;
  }
},
getBharatSatViewExamList: async (bharatSatSubmissions_id,subject_id) => {
  try {
    const response = await axios.get(
      ApiConstants.getBharatSatViewExamList +
        `?bharatSatSubmissions_id=${bharatSatSubmissions_id}&subject_id=${subject_id}`,
      {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.error);
    }
  } catch (error) {
    throw error;
  }
},
deletebharatsatresult: async (id) => {
  try {
    const response = await axios.post(
      ApiConstants.deletebharatsatresult,
      {
        id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.error);
    }
  } catch (error) {
    throw error;
  }
},
addstudentrank: async (rank,bharatSatSubmissions_id) => {
  try {
    const response = await axios.post(
      ApiConstants.addstudentrank,
      {
        rank:rank,
        bharatSatSubmissions_id: bharatSatSubmissions_id,
        
      },
      {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.error);
    }
  } catch (error) {
    throw error;
  }
}

};

export default BharatSatService;
